"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePropertyTypeFieldFiltering = void 0;
var RealEstate_1 = require("../../constants/SearchPageCategories/RealEstate");
var FromDeveloper_1 = require("../../constants/SearchPageCategories/FromDeveloper");
var StructureTypes_1 = require("../../constants/SearchPageCategories/StructureTypes");
var RoomWithPropertyAndStructureType_1 = require("../../constants/SearchPageCategories/RoomWithPropertyAndStructureType");
var PropertyTypes_1 = require("../../constants/SearchPageCategories/PropertyTypes");
var PropertyTypes_2 = require("../../types/SearchPage/PropertyTypes");
var RoomWithPropertyType_1 = require("../../constants/SearchPageCategories/RoomWithPropertyType");
var RentalPriceTypes_1 = require("../../constants/SearchPageCategories/RentalPriceTypes");
var makePropertyTypeFieldFiltering = function (value, propertyTypeQuery, setPropertyTypeQuery, isDeveloperQuery, structureTypeQuery, roomsQuery, replacePageURL, currentLanguage, deal, rentalPrizeQuery, setIsDeveloperQuery, setStructureTypeQuery, setRoomsQuery) {
    if (value === propertyTypeQuery[0]) {
        setPropertyTypeQuery([]);
        if ((isDeveloperQuery === null || isDeveloperQuery === void 0 ? void 0 : isDeveloperQuery.length) ||
            !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) ||
            !(roomsQuery === null || roomsQuery === void 0 ? void 0 : roomsQuery.length) ||
            !rentalPrizeQuery.length) {
            setIsDeveloperQuery([]);
            setStructureTypeQuery(undefined);
            setRoomsQuery([]);
            replacePageURL(RealEstate_1.REAL_ESTATE[currentLanguage].REAL_ESTATE);
        }
    }
    else {
        if ([
            PropertyTypes_2.PROPERTY_TYPE.APARTMENT,
            PropertyTypes_2.PROPERTY_TYPE.HOUSE,
            PropertyTypes_2.PROPERTY_TYPE.COMMERCIAL,
        ].includes(value)) {
            setPropertyTypeQuery([value]);
            if (!isDeveloperQuery.length &&
                !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
                !roomsQuery.length &&
                rentalPrizeQuery.length) {
                replacePageURL(RentalPriceTypes_1.RentalPriceTypes[currentLanguage][deal]
                    .WITH_PROPERTY_TYPE[value]);
            }
            if (isDeveloperQuery.length &&
                !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
                !roomsQuery.length &&
                !rentalPrizeQuery.length) {
                replacePageURL(FromDeveloper_1.FromDeveloperTypes[currentLanguage][deal][value]);
            }
            if ((structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
                !isDeveloperQuery.length &&
                !roomsQuery.length &&
                !rentalPrizeQuery.length) {
                replacePageURL(StructureTypes_1.STRUCTURE_TYPES[currentLanguage][deal][value]);
            }
            if ((structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
                isDeveloperQuery.length &&
                !roomsQuery.length &&
                !rentalPrizeQuery.length) {
                replacePageURL(FromDeveloper_1.DeveloperWithStructurePropertyType[currentLanguage][deal][value]);
            }
            if ((structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
                !isDeveloperQuery.length &&
                roomsQuery.length &&
                !rentalPrizeQuery.length) {
                replacePageURL(RoomWithPropertyAndStructureType_1.RoomWithPropertyAndStructureType[currentLanguage][deal][value][roomsQuery[0]]);
            }
            if (!isDeveloperQuery.length &&
                !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
                roomsQuery.length &&
                !rentalPrizeQuery.length) {
                replacePageURL(RoomWithPropertyType_1.ROOM_WITH_PROPERTY_TYPE[currentLanguage][value][roomsQuery[0]]);
            }
            if (!isDeveloperQuery.length &&
                !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
                !roomsQuery.length &&
                !rentalPrizeQuery.length) {
                replacePageURL(PropertyTypes_1.PROPERTY_TYPES[currentLanguage][deal][value]);
            }
        }
    }
};
exports.makePropertyTypeFieldFiltering = makePropertyTypeFieldFiltering;
